module.exports = __webpack_public_path__ + "1296aa3c2f35decbb32fad27ed82ba03.svg";